import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../hooks/customReduxHooks";
import { selectEwusPatientInsuranceDeclaration, selectEwusPatientNfzRegionalBranchCode, selectEwusResult, selectEwusStatus } from "../../../store/ewusSlice";
import Pill from "../../common/Pill/Pill";
import i18nNamespaces from "../../../const/i18nNamespaces";
import ErrorIcon from "../../common/icons/ErrorIcon/ErrorIcon";
import { Box, Link } from "@material-ui/core";

const PatientInsurancePill = ({onClick}: {onClick?: () => void}) => {
    const {t} = useTranslation(i18nNamespaces.PRESCRIPTIONS);
    const ewusResult = useAppSelector(selectEwusResult);
    const ewusStatus = useAppSelector(selectEwusStatus);
    const patientDeclaredPublicInsurance = useAppSelector(selectEwusPatientInsuranceDeclaration);
    const nfzPatientRegionalBranchCode = useAppSelector(selectEwusPatientNfzRegionalBranchCode);

    let content = null;

    if(ewusStatus === 'loading' || ewusStatus === null) return null;
    
    if(patientDeclaredPublicInsurance === false)
        content = (
            <Box style={{ display: 'flex', alignItems: 'center'}}>
                <ErrorIcon style={{ marginRight: 8 }} />
                <Box>
                    {`${t('patientDidNotApplyForReimbursementOrDeclaredNotInsured')}, `}
                    <Link color='secondary' style={{fontWeight: 'bold'}}>{t('checkEwus')}</Link>
                </Box>
            </Box>
        );
    else if(ewusResult?.status === true && nfzPatientRegionalBranchCode) 
        content = <Pill color="success" content={t('patientInsured')} />;
    else if(ewusResult?.status === true && !patientDeclaredPublicInsurance)
        content = (
            <Box style={{ display: 'flex', alignItems: 'center'}}>
                <ErrorIcon style={{ marginRight: 8 }} />
                <Box>
                    {`${t('patientDidNotApplyForReimbursementOrDeclaredNotInsured')}, `}
                    <Link color='secondary' style={{fontWeight: 'bold'}}>{t('checkEwus')}</Link>
                </Box>
            </Box>
        );
    else if(ewusResult?.status === false)
        content = <Pill color="error" content={t('patientNotInsured')} />;
    else
        content = (
            <Box style={{ display: 'flex', alignItems: 'center'}}>
                <ErrorIcon style={{ marginRight: 8 }} />
                <Box>
                    {`${t('noInfoAboutInsurance')}, `}
                    <Link color='secondary' style={{fontWeight: 'bold'}}>{t('checkEwus')}</Link>
                </Box>
            </Box>
        );

    return (
        <Box onClick={onClick} style={{ cursor: 'pointer' }}>
            {content}
        </Box>
    )
}

export default PatientInsurancePill;